// sessions/utils/normalizeSession.js
export const normalizeSession = (row) => ({
    ...row,

    // IDs
    sessionId: row.sessionId || row._id || "N/A",

    // Location
    locationName:
        row.locationName ||
        row.chargerLocation?.locationName ||
        "N/A",

    // Energy
    EnergyConsumed:
        row.EnergyConsumed ||
        row.energy_disp1 ||
        null,

    //Duration
    duration: row.duration || row.chargeTime || "00:00:00",

});
